export default function Footer() {
  return (
    <footer className="relative z-10 border-t border-bord py-7 px-5 sm:px-8 bg-bg2">
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row justify-between items-center gap-4 flex-wrap">
        <div className="flex items-center gap-2">
          <div className="w-6 h-6 rounded-lg bg-gradient-to-br from-aws to-aws2 flex items-center justify-center font-mono font-black text-[10px] text-black">A</div>
          <span className="font-mono text-[11px] text-tx3">Akrosh R M — Full Stack Developer</span>
        </div>
        <div className="flex gap-4 flex-wrap justify-center">
          {[['React.js','#00D8FF'],['Node.js','#10B981'],['AWS','#FF9900'],['PostgreSQL','#4A90C4']].map(([t,c])=>(
            <span key={t} className="font-mono text-[10px] opacity-60" style={{ color: c }}>{t}</span>
          ))}
        </div>
        <div className="flex items-center gap-2">
          <div className="w-1.5 h-1.5 rounded-full bg-grn animate-pulse-dot" />
          <span className="font-mono text-[10px] text-tx3">Gulbarga, India · 2026</span>
        </div>
      </div>
    </footer>
  );
}
